<template>
  <AreaSimple>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12"  align="center">
          <v-chip>
            CÓDIGO DE SEGUIMIENTO: <b class="px-2"> {{ $route.params.guia }}</b>
          </v-chip>
          <v-btn
              v-show="viewButton"
              class="ma-2"
              outlined
              x-small
              fab
              color="black"
              title="Volver"
              @click="$router.push('/')"
          >
            <v-icon>keyboard_return</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="Object.keys(guiaActual).length">
        <v-col cols="12" md="10" align="center">
          <vue-stepper :tracking="guiaActual"/>
        </v-col>
      </v-row>

      <v-row  justify="center">
        <v-col cols="12" md="10" align="right">
          <v-btn v-show="viewButton"
              :loading="loading"
              :disabled="loading"
              color="blue-grey"
              class="ma-2 white--text"
              @click="getTrackingInfo"
          >
            Actualizar
            <v-icon
                right
                dark
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify="center" v-if="error">
        <v-col cols="12" md="4">
          <v-alert
              color="red lighten-1"
              dark
              dense
              icon="report"
              prominent
          >
            <b class="text-md-h6">
              {{ error }}
            </b>

          </v-alert>
        </v-col>
      </v-row>

    </v-container>

  </AreaSimple>
</template>

<script>
import AreaSimple from "../layouts/AreaSimple";
import VueStepper from "../components/VueStepper";
import guias from "../store/guias";

export default {
  name: "Tracking",
  components: {VueStepper, AreaSimple},
  data() {
    return {
      guiaActual: {},
      error: '',
      loading: false,
      viewButton: false
    }
  },
  mounted() {
    // console.log("Guia recibida", this.$route.params.guia)
    // console.log("Token recibido", this.$route.params.token)
    if (this.$route.params.guia)
      this.getTrackingInfo()
    else
      this.$router.push({name: 'Home'})
  },
  methods: {
    async getTrackingInfo() {
      this.guiaActual = {}
      this.viewButton = false
      try {
        this.loading = true
        this.guiaActual = await guias.getByComprobante(this.$route.params.guia)
        // console.log("Guia actual", this.guiaActual)
        this.viewButton = !Object.is(this.guiaActual.Estado, 'ENTREGADO')            

        if (this.guiaActual.TokenAccesoTracking) {
          if (this.guiaActual.TokenAccesoTracking!==this.$route.params.token) {
            this.guiaActual={}
            this.viewButton = false
            this.error="Token inválido para la guía seleccionada - Debe ingresar desde el link que ha recibido por email"
          }
        }

      } catch (error) {
        console.log("Error", error);
        this.error = error
        // console.log(this.error)
        this.guiaActual = {}
      } finally {
        this.loading = false
        // this.viewButton = true
      }
    }
  }
}
</script>

<style scoped>

</style>